import { useState } from "react"
import { Calendar, CircleX } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox" // Assuming you have this component
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

const currentYear = new Date().getFullYear()

const years = Array.from({ length: 30 }, (_, i) => `${currentYear - i}`)

export function YearRangePicker({
  selectedYears,
  setSelectedYears,
}: {
  selectedYears: string[]
  setSelectedYears: React.Dispatch<React.SetStateAction<string[]>>
}) {
  const [open, setOpen] = useState(false)

  const toggleYear = (year: string) => {
    setSelectedYears((prev) =>
      prev.includes(year)
        ? prev.filter((y) => y !== year)
        : [...prev, year].sort((a, b) => parseInt(a) - parseInt(b)),
    )
  }

  const display =
    selectedYears.length > 0 ? selectedYears.join(", ") : "Select years"

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative w-full">
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={`${selectedYears.length ? "pr-9" : "text-xs"} w-full justify-between text-muted-foreground hover:text-muted-foreground`}
          >
            {display}
            <Calendar
              className={`${selectedYears.length ? "hidden" : ""} ml-2 h-4 w-4 text-muted-foreground`}
            />
          </Button>
        </PopoverTrigger>

        {selectedYears.length > 0 && (
          <span
            onClick={(e) => {
              e.stopPropagation()
              setSelectedYears([])
            }}
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
          >
            <CircleX className="h-4 w-4 text-muted-foreground" />
          </span>
        )}
      </div>

      <PopoverContent className="p-0">
        <Command>
          <CommandInput placeholder="Search year..." />
          <CommandList>
            <CommandEmpty>No years found.</CommandEmpty>
            <CommandGroup>
              {years.map((year) => (
                <CommandItem
                  key={year}
                  onSelect={() => toggleYear(year)}
                  className="flex cursor-pointer items-center gap-2"
                >
                  <Checkbox checked={selectedYears.includes(year)} />
                  {year}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}

//this component use to set range year, e.g. (2021 -> 2025)
/* import { useState } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Command, CommandItem, CommandGroup, CommandEmpty, CommandList, CommandInput } from '@/components/ui/command';

import { Calendar, CircleX, MoveRight } from 'lucide-react';

const years = Array.from({ length: 30 }, (_, i) => `${2025 - i}`);

export function YearRangePicker() {
    const [startYear, setStartYear] = useState<string | null>(null);
    const [endYear, setEndYear] = useState<string | null>(null);
    const [open, setOpen] = useState(false);
    const [selecting, setSelecting] = useState<'start' | 'end'>('start');

    const handleSelect = (year: string) => {
        if (selecting === 'start') {
            setStartYear(year);
            setSelecting('end');
        } else {
            setEndYear(year);
            setOpen(false);
            setSelecting('start');
        }
    };

    const display = startYear || endYear ? (
        <>
            {startYear ?? "Start year"} <span> <MoveRight /> </span> {endYear ?? "End year"}
        </>
    ) : (

        <>
            {"Start year"} <span> <MoveRight /> </span> {"End year"}
        </>

    );
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <div className="relative w-full">
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        className={`${startYear && endYear ? "pr-9" : "text-xs"} hover:text-muted-foreground w-full justify-between text-muted-foreground`} // Add space for icon
                    >
                        {display}
                        <Calendar className={`${startYear && endYear ? "hidden" : ""} ml-2 h-4 w-4 text-muted-foreground`} />
                    </Button>
                </PopoverTrigger>

                {startYear && endYear && (
                    <span
                        onClick={(e) => {
                            e.stopPropagation()
                            setStartYear(null)
                            setEndYear(null)
                        }}
                        className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                    >
                        <CircleX className="h-4 w-4 text-muted-foreground" />
                    </span>
                )}
            </div>


            <PopoverContent className="p-0">
                <Command>
                    <CommandInput placeholder="Search year..." />
                    <CommandList>
                        <CommandEmpty>No years found.</CommandEmpty>
                        <CommandGroup>
                            {years.map((year) => (
                                <CommandItem
                                    key={year}
                                    onSelect={() => handleSelect(year)}
                                    className={`cursor-pointer ${(year === startYear || year === endYear) ? 'bg-muted' : ''}`}
                                    disabled={startYear ? parseInt(year) < parseInt(startYear) : false}
                                >
                                    {year}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>

        </Popover>
    );
}
 */
